import { InjectionToken, Provider } from '@angular/core';
import { Addresses, OccCustomerConsignment, Options, PaymentMode, ReceiptType, TimeSlots } from '@checkout/const';
import { ActionReducerMap } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import {
  CUSTOMER_CONSIGNMENT,
  CustomCheckoutState,
  OPTIONS,
  PAYMENT_MODE_LIST,
  RECEIPT_TYPES,
  SAVED_ADDRESS_LIST,
  TIME_SLOTS,
  USER_PICKUP_SHOP_LIST,
} from '../checkout-state';
import { reducer as activeModesReducer } from './active-modes.reducer';
import { reducer as orderDetailsReducer } from './order-details.reducer';
import { reducer as redirectedToPaymentPageReducer } from './redirected-to-payment-page.reducer';

export type CheckoutReducers = CustomCheckoutState;

export function getReducers(): ActionReducerMap<CheckoutReducers> {
  return {
    receiptType: StateUtils.loaderReducer<ReceiptType[]>(RECEIPT_TYPES),
    activeModes: activeModesReducer,
    timeSlots: StateUtils.loaderReducer<TimeSlots>(TIME_SLOTS),
    addressList: StateUtils.loaderReducer<Addresses>(SAVED_ADDRESS_LIST),
    userPickupShopList: StateUtils.loaderReducer<Pos[]>(USER_PICKUP_SHOP_LIST),
    options: StateUtils.loaderReducer<Options>(OPTIONS),
    redirectedToPaymentPage: redirectedToPaymentPageReducer,
    orderDetails: orderDetailsReducer,
    paymentModeList: StateUtils.loaderReducer<PaymentMode[]>(PAYMENT_MODE_LIST),
    customerConsignment: StateUtils.loaderReducer<OccCustomerConsignment>(CUSTOMER_CONSIGNMENT),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CheckoutReducers>> = new InjectionToken<
  ActionReducerMap<CheckoutReducers>
>('CheckoutReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
